import { EditorRouteStop } from "../../types/RouteStop";

// Completed stops occupy a contiguous suffix of the editor's stops array. That keeps a remaining
// stop's index within `remainingStops` equal to its index within `stops`, so `insertAt` and
// `reorderStop`'s `fromIndex`/`toIndex` — both indices over the remaining stops — need no
// translation before they're applied to the array the reducer mutates. Where the sidebar and map
// actually draw completed stops is a separate, unrelated concern — do not reorder this array to
// match whatever the display does; doing so would silently break insert and drag.
const withCompletedStopsLast = (stops: EditorRouteStop[]): EditorRouteStop[] => [
  ...stops.filter((stop) => !stop.checkedOff),
  ...stops.filter((stop) => stop.checkedOff),
];

export default withCompletedStopsLast;
